import styled from 'styled-components';
import {dFlexCenter, ellipsisLines, mobileMedia} from '../../../globalVariables/GlobalVariables';
import {eyeSection} from '../../components/eyeHideSection/EyeHideSection.css';
import {dFlexColumnCenter} from '../../../globalVariables/GlobalFlex';
export const wrapper=styled.div`
    ${dFlexCenter};
    gap: 20px;
     >div{
        max-width: 33%;
        width: fit-content;
        margin: 20px;
        height: 100px;
        >${eyeSection}{
          position: relative;
          margin-inline-start: 30%;
        }
    }
    } 
     ${mobileMedia}{
      ${dFlexColumnCenter};
    } 
 }
`;

export const detail=styled.div`
   ${dFlexColumnCenter};
   align-content: flex-end;
   width: max-content;
`;
export const text=styled.div`
   margin-top: 10px;
   font-size: 13px;
   width: 100%;   
   ${ellipsisLines(3)}
   ${mobileMedia}{
        font-size: 11px;
   }
`;